export default theme => ({
  root: {
    padding: theme.spacing.unit * 3
  },
  item: {
    height: '100%'
  }
});
